import { SCALE_FALLBACK_COLOR } from '../core/constants.js';

export const zIndicesCategoricalAreas = {
  magnifier: 1,
  dataPoints: 2,
  toolbar: 3,
};

export const DEFAULT_SCALE_FALLBACK_COLOR = SCALE_FALLBACK_COLOR;

export const VARIANT_GROUPED = 'grouped';

export const CATEGORICAL_BAR_CHART_ARIA_LABEL = 'Categorical Bar Chart';
export const DISPLAY_NAME = 'CategoricalBarChart';
